import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

import {
  getOrganizationSlug,
  getDefaultOpenFromRoute,
  getClimateInsightsAccess,
} from 'store/company/selectors';
import { trackPageViewSettings } from 'store/company/actions';

import {
  getIncidentTypes,
  getIsIncidentTypesFetching,
  getIncidentTypeCategories,
  getIsIncidentTypeCategoriesFetching,
} from 'store/incidents/selectors';
import {
  requestIncidentTypeCategories,
  requestIncidentTypes,
  requestUpdateIncidentState
} from 'store/incidents/actions';

import SettingsIncidents from '../components/SettingsIncidents';

const mapDispatchToProps = {
  trackPageViewSettings,
  requestIncidentTypeCategories,
  requestIncidentTypes,
  requestUpdateIncidentState,
};

const mapStateToProps = (state, props) => ({
  ...props,

  organizationSlug: getOrganizationSlug(state, props),
  isSettingsFetching: getIsIncidentTypesFetching(state, props) || getIsIncidentTypeCategoriesFetching(state, props),
  defaultOpen: getDefaultOpenFromRoute(state, props),
  incidentTypes: getIncidentTypes(state, props),
  incidentTypeCategories: getIncidentTypeCategories(state, props),
  incidentsAccess: getClimateInsightsAccess(state, props),
});

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(SettingsIncidents)));
